import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useScreenOrientationType, useVideoRotationOffset, } from '@streamr/tv-ui';
import { useMemo } from 'react';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { EnvironmentService } from '../../services/environment/EnvironmentService';
import { PluginApiService } from '../../services/pluginapi/PluginApiService';
import { PluginListService } from '../../services/pluginlist/PluginListService';
import { formPluginUrl } from '../../utils/routes';
import { hiddenFrameClassName } from './hiddenStyles';
export function PluginComponentContainer({ slotId, }) {
    const pluginApiService = PluginApiService.getNotificationInterface();
    const { myRole } = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const isMobile = EnvironmentService.getOutput().useIsMobile();
    const pluginOutputSlots = PluginListService.getOutput().useSlots();
    const currentSlotFrames = pluginOutputSlots[slotId];
    const orientation = useScreenOrientationType();
    const { videoRotationOffset } = useVideoRotationOffset();
    const isLandscape = (orientation.includes('landscape') && videoRotationOffset === 0) ||
        (orientation.includes('portrait') && videoRotationOffset !== 0);
    // Create a stable map of ref callbacks to prevent unnecessary re-renders
    const iframeRefCallbacks = useMemo(() => {
        const callbacks = {};
        // TODO: Modify the output to work with this to optimize react redraws
        Object.keys(currentSlotFrames).forEach((keyWithinSlot) => {
            callbacks[keyWithinSlot] = (iframe) => {
                if (iframe !== null) {
                    pluginApiService.notifyIframeMounted(slotId, keyWithinSlot, currentSlotFrames[keyWithinSlot], iframe);
                }
            };
        });
        return callbacks;
    }, [pluginApiService, slotId, currentSlotFrames]);
    return (_jsx(_Fragment, { children: Object.keys(currentSlotFrames).map((keyWithinSlot) => {
            const frame = currentSlotFrames[keyWithinSlot];
            if (frame.loadOnlyAtRole && frame.loadOnlyAtRole !== myRole) {
                return null;
            }
            if (frame.loadOnlyOnDeviceType &&
                frame.loadOnlyOnDeviceType !==
                    (isMobile ? 'mobile' : 'desktop')) {
                return null;
            }
            const layout = frame.type === 'component'
                ? isLandscape
                    ? frame.layouts?.landscape
                    : frame.layouts?.portrait
                : undefined;
            return (_jsx(ComponentIFrame, { title: `${frame.id} ${keyWithinSlot}`, src: formPluginUrl(frame.pluginId, frame.urlPath), className: (frame.hidden ?? frame.hiddenByDefault)
                    ? hiddenFrameClassName
                    : '', ref: iframeRefCallbacks[keyWithinSlot], style: {
                    width: layout?.width ?? 'auto',
                    height: layout?.height ?? 'auto',
                    top: layout?.top ?? 'auto',
                    left: layout?.left ?? 'auto',
                    right: layout?.right ?? 'auto',
                    bottom: layout?.bottom ?? 'auto',
                } }, keyWithinSlot));
        }) }));
}
const ComponentIFrame = styled.iframe `
    position: absolute;
    z-index: 1002;
    background: transparent;
    opacity: 1;
    pointer-events: auto;
`;
